export type CompletedChecklist = {
  checklistId: string;
  roomName: string;
  orderNumber: string;
  created: string | null;
  completedAt: string | null;

  averageRating: number | null;
  photoAndVideoDocumentation: number | null;
  installation: number | null;
  comments: number | null;
};

export type UserStatistics = {
  userId: string;
  numberOfCompletedChecklists: number;
  //completedChecklists: CompletedChecklist[];
  averageRating: number;
  averagePhotoRating: number;
  averageInstallationRating: number;
  averageCommentRating: number;
};

// export type CompletedChecklistsResponse = {
//   userId: string;
//   completedChecklists: CompletedChecklist[];
// };

export type TimePeriod = "FROM_START" | "PAST_WEEK" | "PAST_MONTH" | "PAST_YEAR";

export const TimePeriodValues: { [key in TimePeriod]: string } = {
  FROM_START: "Från början",
  PAST_WEEK: "Senaste veckan",
  PAST_MONTH: "Senaste månaden",
  PAST_YEAR: "Senaste året",
} as const;

// export type CompletedChecklistsRequest = {
//   userId: string;
//   timePeriod: TimePeriod;
//   onlyIncludeApprovedChecklists: boolean;
// };
